<template>
<span class="w-block" :style="{height: height + 'px'}">
    <slot>{{title}}</slot>
</span>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default () {
                return []
            }
        },
        height: {
            style: Number
        }
    },
    data() {
        return {
            title: ''
        }
    },
    methods: {},
    mounted() {}
}
</script>

<style lang="scss">
.w-block {
    width: 100%;
    height: 18vh;
    display: inline-block;
    padding: 10px;
    position: relative;
    left: 30px;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/w-block.vue